<!--
@see https://app.clickup.com/2409014/v/dc/29ghp-41007/29ghp-62287
		 Documenation on Transaction History
-->

<template>
	<Loader v-if="loading" />
	<div v-else>

		<button v-on:click="reload">Reload</button>
		<button v-on:click="add_bankpayment = !add_bankpayment" class="small-margin-left">Add bank payment</button>

		<div v-if="add_bankpayment" class="margin-top margin-bottom">
			<AddBankPayment :orderid="id" :countryId="this.countryId" class="margin-top" v-on:created="reload()"  />
		</div>

		<div class="margin-top">
			<div v-if="Object.keys(transaction_history).length" class="transaction-history-header">
				<div></div>
				<div>Type</div>
				<div>Amount</div>
				<div>Date</div>
				<div>Comment</div>
			</div>
			<div v-for="item in transaction_history" class="margin-top transaction-history-item">

				<div class="transaction-history-col">
					<div class="icon">
						<SvgIcon v-if="item.dispute" name="warning" />
						<PaymentMethodIcon
							v-else
							:source="item.payment_channel.identifier"
							/>

						<div
							class="return"
							v-if="item.amount < 0"><SvgIcon name="back" /></div>
					</div>
				</div>

				<div class="transaction-history-col">
					<span class="source-name">{{ item.payment_channel.name }}</span>

          <span
            style="margin-left: 10px; background: rgb(220, 10, 10); padding: 4px 8px; color: #fff; width: fit-content; border-radius: 4px; font-weight: bold;"
            v-if="item.state == 'cancelled' && item.authorization">Auth. cancelled</span>
					<span
						style="margin-left: 10px; background: rgb(20, 220, 10); padding: 4px 8px; color: #fff; width: fit-content; border-radius: 4px; font-weight: bold;"
						v-else-if="item.state == 'charge' && item.authorization">Auth. settled</span>
					<span
						style="margin-left: 10px; background: red; padding: 4px 8px; color: #fff; width: fit-content; border-radius: 4px; font-weight: bold;"
						v-else-if="item.state == 'failed'">Auth. Failed</span>
					<span
						style="margin-left: 10px; background: orange; padding: 4px 8px; color: #fff; width: fit-content; border-radius: 4px; font-weight: bold;"
						v-else-if="item.state == 'authorization' || item.authorization">Authorized</span>
				</div>

				<div class="transaction-history-col">
					<span v-if="item.dispute" class="small-margin-top" v-bind:class="{
						error: ['open', 'lost'].indexOf(item.dispute.dispute_status) >= 0,
						green: item.dispute.dispute_status == 'won',
					}">
						<strong v-if="item.dispute.dispute_status != 'won'">
							Disputed!
							<template v-if="item.dispute.dispute_status == 'open'">(Awaiting response)</template>
							<template v-if="item.dispute.dispute_status == 'lost'">(Lost)</template>
						</strong>
						<strong v-else>Dispute won</strong>
					</span>
					<template v-if="item.currency && item.payment_method">
						{{ item.amount < 0 ? ' Refunded ' : '' }} {{ item.currency.code }} {{ abs(item.amount) }}
					</template>
					<template v-else>
						{{ item.amount < 0 ? ' refunded ' : ' paid ' }} {{ abs(item.amount) }}
					</template>
					<template v-if="item.meta">
						<div v-if="item.meta.aggressor" class="small-margin-top">
							<em>Claimed by <strong>Aggressive Failed Payment Strategy</strong></em>
						</div>
					</template>
				</div>

				<div class="transaction-history-col"><span>{{ item.date.substr(0, 16) }}</span></div>

				<div class="transaction-history-col comment">
					<span>{{ item.comment }}</span>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import AddBankPayment from '@/components/AddBankPayment.vue'
import PaymentMethodIcon from '@/components/PaymentMethodIcon.vue'

export default {
  props: [
    'id',
    'autoload',
    'countryId'
  ],

  components: {
    AddBankPayment,
    PaymentMethodIcon
  },

  data: () => ({
    loading: false,
    transaction_history: [],
    add_bankpayment: false
  }),
  methods: {
    abs (amount) {
      return Math.abs(amount)
    },
    reload () {
      this.load()
    },
    load () {
      Vue.api.get('/order/' + this.id + '/transaction-history', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.transaction_history = _.orderBy(data, (item) => {
        return item.date
      }, ['desc'])
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>

<style lang="less">
	.transaction-history-item {
		display: flex;
		align-items: center;
		position: relative;
		.icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 60px;
			padding: 10px;
			//border: 2px solid #535353;
			border-radius: 50%;
			margin-right: 15px;
			position: relative;
			background: #fff;
			z-index: 50;
			svg {
				width: 28px !important;
				height: 28px !important;
				fill: #535353;
			}
			.return {
				position: absolute;
				bottom: 0px;
				right: 0px;
				background: #fff;
				border-radius: 50%;
				border: 2px solid #333;
				width: 40px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				svg {
					fill: #333;
				}
			}
		}
		&::after {
		}
		&:nth-child(1) {
			&::after {
				top: 10px;
			}
		}
		&:last-child {
			&::after {
				bottom: 10px;
			}
		}
		.transaction-history-col {
			&:first-of-type {
				width: 90px;
				padding: 0;
			}
			&:nth-child(2) {
				width: 300px;
			}
			padding: 0 15px;
			width: 15%;
			&.comment {
				width: 200px;
			}
		}
		.source-name {
			text-transform: capitalize;
		}
	}
	.transaction-history-header {
		display: flex;
		div {
			&:first-of-type {
				width: 90px;
				padding: 0;
			}
			&:nth-child(2) {
				width: 300px;
			}
			width: 15%;
			padding: 0 15px;
			font-weight: bold;
		}
	}
</style>
